import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { buildAetUserContext, getPreferredUserIdentifier } from '../core/constant/user-context.util';

export interface AetImportUploadRequestDto {
  guid: string;
  validationOnly: boolean;
  importType: 'AET_IMPORT' | 'AET_EVENTS_RESOLUTIONS';
  userReqDto: ReturnType<typeof buildAetUserContext>;
  templateMeta?: {
    fileName?: string;
    sheetNames?: string[];
    hasEventsSheet?: boolean;
    hasResolutionsSheet?: boolean;
  };
}

@Injectable({
  providedIn: 'root'
})
export class FtpfileImportService {
  pageNumber: any;
  pageSize: any

  baseURL = environment.baseAPIURL;
  constructor( private readonly http  : HttpClient) { }

  uploadImportFileToLambda(excelFile: File, requestDto: AetImportUploadRequestDto): Observable<any> {
    const formData: FormData = new FormData();
    const compactRequestDto = {
      guid: requestDto.guid,
      validationOnly: requestDto.validationOnly,
      importType: requestDto.importType,
      templateMeta: requestDto.templateMeta,
    };
    formData.append('file', excelFile, excelFile.name);
    formData.append('request', JSON.stringify(compactRequestDto));
    formData.append('guid', requestDto.guid || '');
    formData.append('validationOnly', String(requestDto.validationOnly));
    formData.append('importType', requestDto.importType);
    if (requestDto.templateMeta) {
      formData.append('templateMeta', JSON.stringify(requestDto.templateMeta));
    }

    const token = sessionStorage.getItem('accessToken') || sessionStorage.getItem('idToken') || '';
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;

    return this.http.post(`${environment.FILE_UPLOAD_URI}/uploadimportfile`, formData, { headers }).pipe(catchError(this.handleError));
  }

  private appendCommonUploadFields(formData: FormData, toyotaGUID: any, excelFile: File, validation: 'true' | 'false'): void {
    const userIdentifier = getPreferredUserIdentifier(toyotaGUID);
    formData.append('file', excelFile, excelFile.name);
    formData.append('upn', userIdentifier);
    formData.append('validation', validation);
    // For modernized backend/lambda contract: include full user context in multipart payload.
    formData.append('userReqDto', JSON.stringify(buildAetUserContext()));
  }
  
  loadOnLoad(pageNumber: any,pageSize: any)
  {

      
    return this.http.get(`${this.baseURL}/aetImport/getAetFtpFileImport/${pageNumber}/${pageSize}`).pipe(catchError(this.handleError)) 
  }

  searchJobs(data) {
    return this.http.get(`${this.baseURL}/aetImport/searchJobs/${data.pageNumber}/${data.pageSize}${data.queryString}`).pipe(catchError(this.handleError)) 
  }

  validateFileService(toyotaGUID,excelFile: File): Observable<any> {
    const formData: FormData = new FormData();
    this.appendCommonUploadFields(formData, toyotaGUID, excelFile, 'true');
    return this.http.post(`${this.baseURL}/aetImports/validateExcel`, formData,
      { responseType: 'blob', observe:'response' })
      .pipe(
        catchError(this.handleError));
  }
  

  uploadFileService(toyotaGUID,excelFile: File): Observable<any> {
    const formData: FormData = new FormData();
    this.appendCommonUploadFields(formData, toyotaGUID, excelFile, 'false');
    return this.http.post(`${this.baseURL}/aetImports/validateExcel`, formData,
      { responseType: 'blob', observe:'response' })
      .pipe(
        catchError(this.handleError));
  }

  getUploadLogs(toyotaGUID,excelFile: File | string): Observable<any> {
    const formData: FormData = new FormData();
    this.appendCommonUploadFields(formData, toyotaGUID, this.toLookupFile(excelFile), 'true');
    return this.http.post(`${this.baseURL}/aetImports/getLogs`, formData,
      { responseType: 'text', observe:'response' })
      .pipe(
        catchError(this.handleError));
  }

  getImportLogs(toyotaGUID,excelFile: File | string): Observable<any> {
    const formData: FormData = new FormData();
    this.appendCommonUploadFields(formData, toyotaGUID, this.toLookupFile(excelFile), 'false');
    return this.http.post(`${this.baseURL}/aetImports/getLogs`, formData,
      { responseType: 'text', observe:'response' })
      .pipe(
        catchError(this.handleError));
  }

  private toLookupFile(fileOrName: File | string): File {
    if (fileOrName instanceof File) {
      return fileOrName;
    }

    const name = String(fileOrName || '').trim() || 'aet-import-log-lookup.xls';
    return new File([''], name, { type: 'application/vnd.ms-excel' });
  }

  private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}
